import { render, staticRenderFns } from "./CadastroCredenciadoConfirmacao.vue?vue&type=template&id=0daddfea&scoped=true&lang=pug&"
import script from "./CadastroCredenciadoConfirmacao.vue?vue&type=script&lang=js&"
export * from "./CadastroCredenciadoConfirmacao.vue?vue&type=script&lang=js&"
import style0 from "./CadastroCredenciadoConfirmacao.vue?vue&type=style&index=0&id=0daddfea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0daddfea",
  null
  
)

export default component.exports